module.exports = __webpack_public_path__ + "img/crop-image.aa9570f2.png";